import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/NodeContainer/NodeContainer.tsx";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useStore, useStoreMap } from 'effector-react';
import { memo, useCallback, useMemo } from 'react';
import { isNotEmpty } from '@gmini/utils';
import { getNode } from "../../../classifier-service";
import { isAssemblyClassifierNode, isBimNode, isDynamicBimElementReferenceNode, isDynamicGeneratedGroupNode, isReferenceNode, isUserClassifierGroupNode } from "../../../classifier-service/Node";
import { buildTreeItemKey } from "../../ClassifierTree/buildTreeItemKey";
import { buildKeyByPath, createGeneralGroupNode, getParentsByPath } from "../../ClassifierTree/utils";
import { NodeRender } from "../NodeRender";
import { jsx as _jsx } from "react/jsx-runtime";
export var NodeContainer = /*#__PURE__*/memo(function (_ref) {
  var item = _ref.item,
      nodes$ = _ref.nodes$,
      isExpanded = _ref.isExpanded,
      toggle = _ref.toggle,
      renderNodeLayout = _ref.renderNodeLayout,
      onChecked = _ref.onChecked,
      checkbox = _ref.checkbox,
      clsDependenciesRefs = _ref.clsDependenciesRefs,
      onPending = _ref.onPending,
      selectedPath = _ref.selectedPath,
      onLoadMore = _ref.onLoadMore,
      onUpdateDialogOpen = _ref.onUpdateDialogOpen,
      highlightItem = _ref.highlightItem,
      showModelVersion = _ref.showModelVersion,
      searchSourceData$ = _ref.searchSourceData$,
      searchMatched$ = _ref.searchMatched$,
      error = _ref.error;
  //TODO разобраться с типами
  var node = useStoreMap({
    store: nodes$,
    keys: [item.ref],
    fn: function fn(nodes, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          itemRef = _ref3[0];

      if (itemRef.type === 'LoadMore') {
        var refNode = getNode(nodes, itemRef.parentNodeRef);
        var parentNode = null; //TODO разгрести логику формирования parentNode

        if (isReferenceNode(refNode)) {
          parentNode = getNode(nodes, refNode.element);
        } else if ((refNode === null || refNode === void 0 ? void 0 : refNode.type) === 'AssemblyClassifierNode' && refNode !== null && refNode !== void 0 && refNode.assemblyModelRef) {
          parentNode = getNode(nodes, refNode.assemblyModelRef.element);
        } else if (isBimNode(refNode) || isDynamicGeneratedGroupNode(refNode)) {
          parentNode = refNode;
        } else if (isUserClassifierGroupNode(refNode)) {
          parentNode = createGeneralGroupNode(refNode);
        }

        if (!parentNode) {
          return null;
        }

        return _objectSpread(_objectSpread({}, itemRef), {}, {
          parentNode: parentNode
        });
      }

      var n = getNode(nodes, itemRef);

      if (!n) {
        return null;
      }

      if (isUserClassifierGroupNode(n)) {
        return createGeneralGroupNode(n);
      }

      if (isReferenceNode(n) || isDynamicBimElementReferenceNode(n)) {
        var element = getNode(nodes, n.element);
        return element ? _objectSpread(_objectSpread({}, n), {}, {
          type: 'ReferenceNode',
          element: element
        }) : null;
      }

      if (isAssemblyClassifierNode(n) && n.assemblyModelRef) {
        var _element = getNode(nodes, n.assemblyModelRef.element);

        if (!_element) {
          return null;
        }

        return _objectSpread(_objectSpread({}, n.assemblyModelRef), {}, {
          type: 'ReferenceNode',
          element: _element
        });
      } // Сборка без модели


      if (isAssemblyClassifierNode(n)) {
        return null;
      }

      return n;
    }
  });
  var searchMatched = useStore(searchMatched$, {
    loc: {
      file: _effectorFileName,
      line: 131,
      column: 26
    },
    name: "NodeContainer",
    sid: "NodeContainer /src/classifier-editor/DependencyTree/NodeContainer/NodeContainer.tsx [131, 26]"
  });
  var inSearch = useMemo(function () {
    if (!node) {
      return {
        fullMatch: false,
        matched: false,
        source: false
      };
    }

    var key = item.path[item.path.length - 1];

    if (node.type === 'LoadMore') {
      var fullMatchedKey = Object.keys(searchMatched).find(function (value) {
        return searchMatched[value] === 'fullMatch';
      });

      if (!fullMatchedKey) {
        return {
          fullMatch: false,
          matched: false,
          source: false
        };
      }

      var searchedNodeExists = node.parentNode.type === 'BimStandardSizeNode' && node.parentNode.children.some(function (node) {
        return fullMatchedKey === buildTreeItemKey(node);
      });
      return {
        fullMatch: false,
        matched: !searchedNodeExists && searchMatched[buildTreeItemKey(node.parentNodeRef)] === 'match',
        source: false
      };
    }

    return {
      matched: searchMatched[key] === 'match',
      fullMatch: searchMatched[key] === 'fullMatch',
      source: false
    };
  }, [item.path, node, searchMatched]);
  var inSearchSource = useStoreMap({
    store: searchSourceData$,
    keys: [node],
    fn: function fn(searchSourceData, _ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
          node = _ref5[0];

      return !!searchSourceData && ((node === null || node === void 0 ? void 0 : node.type) === 'ReferenceNode' && node.parentClassifierId === searchSourceData.id && node.parentClassifierVersion === searchSourceData.version || (node === null || node === void 0 ? void 0 : node.type) === 'UserClassifierNode' && node.id === searchSourceData.id && node.version === searchSourceData.version);
    }
  });
  var dependencies = useStoreMap({
    store: nodes$,
    keys: [clsDependenciesRefs],
    fn: function fn(nodes, _ref6) {
      var _ref7 = _slicedToArray(_ref6, 1),
          deps = _ref7[0];

      return deps.map(function (r) {
        return getNode(nodes, r);
      }).filter(isNotEmpty);
    }
  });
  var parentNodes = useStoreMap({
    store: nodes$,
    keys: [item.path],
    fn: function fn(nodes, _ref8) {
      var _ref9 = _slicedToArray(_ref8, 1),
          itemPath = _ref9[0];

      return getParentsByPath(nodes, itemPath);
    }
  });
  var isSelected = !!(buildKeyByPath((selectedPath === null || selectedPath === void 0 ? void 0 : selectedPath.path) || []) === buildKeyByPath(item.path));
  var onExpandClick = useCallback(function () {
    if (node && node.type !== 'LoadMore') {
      toggle(node, item.path);
    }
  }, [item.path, node, toggle]);

  if (!node) {
    return null;
  }

  var highlighted = !!highlightItem && buildKeyByPath(highlightItem) === buildKeyByPath(item.path);
  return /*#__PURE__*/_jsx(NodeRender, {
    onUpdateDialogOpen: onUpdateDialogOpen,
    parentNodes: parentNodes,
    isExpanded: isExpanded,
    node: node,
    clsDependencies: dependencies,
    path: item.path,
    onDoubleClickNode: onExpandClick,
    onExpandClick: onExpandClick,
    checkbox: checkbox,
    onCheckedNode: onChecked,
    renderNodeLayout: renderNodeLayout,
    inSearch: inSearch,
    onPending: onPending,
    isSelected: isSelected,
    onLoadMore: onLoadMore,
    highlighted: highlighted,
    showModelVersion: showModelVersion,
    inSearchSource: inSearchSource,
    error: error
  });
});